<div class="py-2">
  <div class="container">
    <h2 class="mb-4">{{data.information_loader_title ?? ""}}</h2>
    <div class="row g-4">
      <div class="col-12 col-md-6 col-lg-4" *ngFor="let page of data.information_loader_informazioni">
        <div class="cmp-card-simple card-wrapper pb-0 rounded border border-light">
          <div class="card shadow-sm rounded">
            <div class="card-body">
              <a [href]="page?.path?.alias" class="text-decoration-none" [attr.data-element]="data?.information_loader_data_element">
                <h3 class="card-title t-primary">{{page.title}}</h3>
              </a>
              <p class="text-secondary mb-0" [innerHTML]="substring(page?.information_desc,0,255)"></p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>